import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { TbArrowRight } from "react-icons/tb";

function NextButton({ nextStep }: { nextStep: () => void }) {
  const { t } = useTranslation();
  return (
    <Button
      icon={<TbArrowRight />}
      onClick={nextStep}
      iconPosition="end"
      type="primary"
      htmlType="button"
    >
      {t("nextStep")}
    </Button>
  );
}

export default NextButton;
